import { Session } from '../Models/session';

export const dateDisplay: (session: Session) => string = (session) => {
    const monthStr = timeNumberDisplay(session.month);
    const dayStr = timeNumberDisplay(session.day);
    const hourStr = timeNumberDisplay(session.hour);
    const minuteStr = timeNumberDisplay(session.minute);

    return `${dayStr}.${monthStr}.${session.year} - ${hourStr}:${minuteStr}`;
};

const timeNumberDisplay: (n: number) => string = (n) => {
    return n < 10 ? '0' + n : n.toString();
};
